import { render, staticRenderFns } from "./CouponReport.vue?vue&type=template&id=f5fc2fdc&scoped=true&"
import script from "./CouponReport.vue?vue&type=script&lang=js&"
export * from "./CouponReport.vue?vue&type=script&lang=js&"
import style0 from "./CouponReport.vue?vue&type=style&index=0&id=f5fc2fdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5fc2fdc",
  null
  
)

export default component.exports